import { types as t, flow } from 'mobx-state-tree';

import { LoadingState } from 'models/ui';
import { withEnv } from 'models/withEnv';

import { configs } from './configs';

const JobBoard = t.model('JobBoard', {
  name: t.string,
  isActive: t.boolean,
});

export const JobBoardsStore = t
  .model('JobBoardsStore', {
    boards: t.array(JobBoard),
    status: t.optional(LoadingState, 'loading'),
  })
  .views(withEnv)
  .views((self) => ({
    get activeBoards() {
      if (self.boards === null) return [];
      return self.boards.filter((board) => board.isActive);
    },
    get availableBoards() {
      if (self.boards === null) return [];
      return self.boards.filter((board) => !board.isActive);
    },
  }))
  .actions((self) => ({
    afterCreate() {
      self.performLoad();
    },
    deactivate: flow(function* (board) {
      const res = yield self.env.api.jobboards.deactivateBoard(board);
      const boardTitle = configs[board].title;
      if (!res.error) {
        yield self.reload();
        self.env.showSuccess(self.env.t('jobboards.disconnect.success'), { subtitle: boardTitle });
        return true;
      } else {
        self.env.showError(self.env.t('jobboards.disconnect.error'));
        return false;
      }
    }),
    activate: flow(function* (board) {
      const res = yield self.env.api.jobboards.activateBoard(board);
      const boardTitle = configs[board].title;
      if (!res.error) {
        yield self.reload();
        self.env.showSuccess(self.env.t('jobboards.connect.success'), { subtitle: boardTitle });
        return true;
      } else {
        self.env.showError(self.env.t('jobboards.connect.error'));
        return false;
      }
    }),
    performLoad: flow(function* () {
      const res = yield self.env.api.jobboards.load();
      if (!res.error) {
        self.boards = res.data;
        self.status = 'loaded';
      } else {
        self.status = 'error';
      }
    }),
    load() {
      if (['loading', 'reloading'].includes(self.status)) return;
      self.status = 'loading';
      return self.performLoad();
    },
    reload() {
      self.status = 'reloading';
      return self.performLoad();
    },
  }));
